(function() {
  'use strict';

  angular
    .module('admin.shelfie_elements.service', [])
    .factory('ShelfieElementsService', ShelfieElementsService);

  /** @ngInject */
  function ShelfieElementsService($http, $q, API) {

    function getUrl() {
      if (window.location.hostname === 'localhost') {
        return 'http://localhost:8080';
      }
      var isProd = API.API_URL.indexOf('prod') !== -1
      var url;
      if (isProd) {
        url = 'https://cbxo05ued2.execute-api.us-east-1.amazonaws.com'
      } else {
        url = 'https://3odg94zefh.execute-api.us-east-1.amazonaws.com'
      }
      return url;
    }

    function listElementTypes(){
      var defer = $q.defer();

      var key = 'shelfies/types.json'
      $http.get(getUrl() + '/upload?key='+key, null, {
        transformRequest: angular.identity,
        headers: {'Content-Type': undefined}
      })
        .success(function(data) {
          defer.resolve(data);
        })
        .error(defer.reject);


      return defer.promise;
    }

    function listElements(id, start, limit){
      var defer = $q.defer();

      var key = 'shelfies/elements.json'
      $http.get(getUrl() + '/upload?key='+key, null, {
        transformRequest: angular.identity,
        headers: {'Content-Type': undefined}
      })
        .success(function(data) {
          defer.resolve(data);
        })
        .error(defer.reject);

      return defer.promise;
    }

    function saveElementType(data){
      var defer = $q.defer();

      $http.post(getUrl() + '/upload/json', {
        json: JSON.stringify(data),
        key: 'shelfies/types.json'
      })
        .success(function() {
          defer.resolve('updated');
        })
        .error(defer.reject);

      return defer.promise;
    }

    function saveElements(data){
      var defer = $q.defer();

      $http.post(getUrl() + '/upload/json', {
        json: JSON.stringify(data),
        key: 'shelfies/elements.json'
      })
        .success(function() {
          defer.resolve('updated');
        })
        .error(defer.reject);

      return defer.promise;
    }

    function uploadShelveImgL(file) {
      var defer = $q.defer();
      var fileName = file.name.replaceAll(' ', '')

      var formData = new FormData()
      formData.append('file',file)
      formData.append('fileName',fileName)
      formData.append('nameFolder','/shelfies/elements/backgrounds')

      $http.post(getUrl() + '/upload/save', formData, {
        transformRequest: angular.identity,
        headers: {'Content-Type': undefined}
      })
        .success(function(data) {
          defer.resolve(data.key);
        })
        .error(defer.reject);

      return defer.promise;
    }

    function uploadAccessoryImg(file) {
      var defer = $q.defer();
      var fileName = file.name.replaceAll(' ', '')

      var formData = new FormData()
      formData.append('file',file)
      formData.append('fileName',fileName)
      formData.append('nameFolder','/shelfies/elements/accessories')

      $http.post(getUrl() + '/upload/save', formData, {
        transformRequest: angular.identity,
        headers: {'Content-Type': undefined}
      })
        .success(function(data) {
          defer.resolve(data.key);
        })
        .error(defer.reject);

      return defer.promise;
    }

    function uploadOverlay(file) {
      var defer = $q.defer();
      var fileName = file.name.replaceAll(' ', '')

      var formData = new FormData()
      formData.append('file',file)
      formData.append('fileName',fileName)
      formData.append('nameFolder','/shelfies/elements/overlays')

      $http.post(getUrl() + '/upload/save', formData, {
        transformRequest: angular.identity,
        headers: {'Content-Type': undefined}
      })
        .success(function(data) {
          defer.resolve(data.key);
        })
        .error(defer.reject);

      return defer.promise;
    }

    return{
      listElementTypes: listElementTypes,
      listElements: listElements,
      saveElementType: saveElementType,
      saveElements: saveElements,
      uploadShelveImgL: uploadShelveImgL,
      uploadAccessoryImg: uploadAccessoryImg,
      uploadOverlay: uploadOverlay,
    };

  }

})();
